<template lang="html">
  <footer style="padding: 2rem;">
    <div class="container">
      <div class="row center middle gutterize content">
        <div>
          <div class="profile shrink-0"></div>
        </div>
        <div>
          <p class="bio" style="margin: 0 0 .5em 0;">
            Noen folk liker fotball, for meg er det webutvikling & design som gjelder.
            Noe av det jeg er mest opptatt av for tiden er:
            <span class="c-primary">Node</span>, <span class="c-secondary">MongoDB</span>, <span class="c-tertiary">Vue</span>, <span class="c-primary">GraphQL</span>.
            <br>Vil du snakke om teknologi så ta kontakt!
          </p>
          <channels></channels>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Channels from "./channels.vue";

export default {
  components: {
    Channels
  }
};
</script>

<style scoped lang="scss">
@import "../styles/base/_colors";

footer {
  padding: 2rem;
  background: white;
}

.profile {
  width: 225px;
  height: 225px;
  background-color: rgba($primary, 0.1);
  border: 2px solid rgba($primary, 0.13);
  background-image: url(/profile.png);
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  background-position: -12px -7px;
}

@media (max-width: 700px) {
  .content {
    flex-wrap: wrap;
  }
}
</style>
